import React, { useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Common from "us.common";
import { IFilter } from "./Interface";
import { messageTemplateAction } from "us.collection.case/actions";
import { EntityType } from "us.collection/constants";
import { IMessageTemplateItem } from "us.collection.case/interfaces";
import { MessageTemplate } from "./Components";
import {
  filterMessageTemplates,
  getMessageTemplatesDisplayNames,
  getEntityTypeForPayload,
} from "./Function";
import {
  DocumentType,
  FilterptionsForTemplate,
  TemplateDrawerType,
} from "us.collection.case/constants";
import "./Home.scss";
import { ReloadOutlined } from "us.icons";
import { RootState } from "us.helper/types";
import TemplateDrawerV2 from "./Components/TemplateDrawer/ContentV2/TemplateDrawer";
import { MessageTemplateSchema } from "./Validations";
import { getCaseNumberAndType } from "us.collection/functions";
import { useLocation, useNavigate } from "react-router-dom";
import { INavigationData } from "us.collection/interfaces";

const {
  messageTemplates,
  deleteMessageTempale,
  messageTemplate,
  pinUnpinTemplate,
  displayName,
  messageContent,
} = messageTemplateAction;

const {
  $Input,
  $Radio,
  $PageHeader,
  $Affix,
  $Skeleton,
  $Empty,
  $Button,
  $Tooltip,
} = Common.Components;

const MessageTemplates: React.FC<PropsFromRedux> = (
  props
) => {
  const { t } = useTranslation();
  const {
    messageTemplates,
    metaData,
    getMessageTemplates,
    deleteMessageTemplate,
    pinUnpinTemplate,
    updateDisplayName,
    handleDrawer
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as INavigationData;
  const { caseNo, arId } = metaData.data ?? {};
  const { type: entityType, url } =
    getCaseNumberAndType(location, metaData.data) ?? {};

  const [filter, setFilter] = useState<IFilter>({
    type: DocumentType.ALL,
    name: "",
  });

  useEffect(() => {
    if (
      getMessageTemplates &&
      (entityType === EntityType.SUBCASE ||
        entityType === EntityType.CASE ||
        entityType === EntityType.AR)
    ) {
      getMessageTemplates({
        entityType: getEntityTypeForPayload(entityType),
      });
    }
  }, [entityType]);

  /**
   * Back navigation
   */
  const minimize = () => {
    (caseNo || arId) &&
      navigate({
        ...location,
        pathname: `/${url}/${entityType === EntityType.AR ? arId : caseNo}`,
      }, { state });
  };

  /**
   * Delete message template
   * @param template
   */
  const onDeleteTemplate = (template: IMessageTemplateItem) => {
    try {
      const { id } = template;
      deleteMessageTemplate && deleteMessageTemplate({ templateId: id });
    } catch (error) {}
  };
  /**
   * Pin or Unpin message template
   * @param template
   */
  const onPinUnpinTemplate = (template: IMessageTemplateItem) => {
    const { id, isPin } = template;

    pinUnpinTemplate &&
      pinUnpinTemplate({
        templateId: id,
        isPin: isPin,
        entityType: getEntityTypeForPayload(entityType),
      });
  };

  /**
   * Open drawer and get message template content
   * @param isPreview
   * @param messageTemplate
   */
  const onPreviewEditDrawer = (
    isPreview: boolean,
    messageTemplate: IMessageTemplateItem
  ) => {
    try {
      const { displayName } = messageTemplate;

        handleDrawer &&
          handleDrawer({
            title: displayName,
            visible: true,
            type: isPreview
              ? TemplateDrawerType.PREVIEW
              : TemplateDrawerType.EDITOR,
            isPreview,
            templateDetails: messageTemplate,
          });
    } catch (error) {}
  };

  /**
   * Refresh message templates
   */
  const onRefresh = () => {
    try {
      getMessageTemplates &&
        getMessageTemplates({
          entityType: getEntityTypeForPayload(entityType),
        });
    } catch (error) {}
  };

  return (
    <Formik
      initialValues={{ displayName: "" }}
      onSubmit={() => {}}
      validationSchema={MessageTemplateSchema(
        getMessageTemplatesDisplayNames(messageTemplates?.data)
      )}
    >
      {() => (
        <>
          <div className="msg-template">
            <$Affix offsetTop={80}>
              <div className="page-header header-border">
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <$PageHeader
                      className="px-0"
                      title={t("US.COLLECTION.CASE:MASSAGETEMPLATES.TITLE")}
                      onBack={minimize}
                    />
                  </div>

                  <div className="ml-5 d-flex align-items-center">
                    <$Tooltip
                      placement="top"
                      title={t("US.COLLECTION.CASE:MASSAGETEMPLATES.REFRESH")}
                    >
                      <$Button
                        className="mr-3"
                        icon={<ReloadOutlined />}
                        type="dashed"
                        size="small"
                        onClick={onRefresh}
                        style={{ marginTop: 2 }}
                      />
                    </$Tooltip>
                    <$Radio
                      size="small"
                      name="documentType"
                      radioButton="true"
                      optionText="label"
                      optionValue="value"
                      defaultValue={"all"}
                      className="d-flex"
                      optionStyle="flex-fill text-center"
                      buttonStyle="solid"
                      data-testid="messageTemplate-documentType"
                      options={FilterptionsForTemplate.map(
                        (option: { key: string; value: string }) => {
                          return {
                            label: t(
                              `US.COLLECTION.CASE:MASSAGETEMPLATES.${option.key}`
                            ),
                            value: option.value,
                          };
                        }
                      )}
                      onChange={(e: any) => {
                        setFilter({ ...filter, type: e.target.value });
                      }}
                    />
                    <$Input
                      name="filter"
                      size="small"
                      className="ml-2"
                      allowClear
                      style={{ width: 240 }}
                      placeholder={t(
                        "US.COLLECTION.CASE:MASSAGETEMPLATES.FILTER_BY_NAME"
                      )}
                      onChange={(e: any) => {
                        setFilter({ ...filter, name: e.target.value });
                      }}
                    />
                  </div>
                </div>
              </div>
            </$Affix>
            <div className="msg-template-view">
              <$Skeleton
                loading={messageTemplates.isLoading}
                active
                paragraph={{ rows: 2 }}
              >
                <div>
                  {filterMessageTemplates(messageTemplates.data, filter)
                    .length > 0 && (
                    <>
                      <div className="msg-template-wrap">
                        <div className="msg-template-inner">
                          {filterMessageTemplates(
                            messageTemplates.data,
                            filter
                          ).map(
                            (messageTemplate: IMessageTemplateItem, index) => {
                              const { isPin, id } = messageTemplate;
                              if (isPin) {
                                return (
                                  <MessageTemplate
                                    key={`${index}-${messageTemplate.displayName}`}
                                    messageTemplate={messageTemplate}
                                    onPreviewEditDrawer={onPreviewEditDrawer}
                                    onDelete={() =>
                                      onDeleteTemplate(messageTemplate)
                                    }
                                    onPinUnpinTemplate={() =>
                                      onPinUnpinTemplate(messageTemplate)
                                    }
                                    metaData={metaData.data}
                                    save={(value: any) =>
                                      updateDisplayName &&
                                      updateDisplayName({
                                        ...value,
                                        entityType:
                                          getEntityTypeForPayload(entityType),
                                      })
                                    }
                                  />
                                );
                              }
                            }
                          )}
                        </div>
                      </div>

                      <div className="ml-2 mt-4 mb-2">
                        <strong data-testid="UnPinTemplate">
                          {t("US.COLLECTION.CASE:MASSAGETEMPLATES.UNPINNED")}
                        </strong>
                      </div>

                      <div className="msg-template-wrap">
                        <div className="msg-template-inner">
                          {filterMessageTemplates(
                            messageTemplates.data,
                            filter
                          ).map(
                            (messageTemplate: IMessageTemplateItem, index) => {
                              const { isPin, id } = messageTemplate;
                              if (!isPin) {
                                return (
                                  <MessageTemplate
                                    key={`${index}-${messageTemplate.displayName}`}
                                    messageTemplate={messageTemplate}
                                    onPreviewEditDrawer={onPreviewEditDrawer}
                                    onDelete={() =>
                                      onDeleteTemplate(messageTemplate)
                                    }
                                    onPinUnpinTemplate={() =>
                                      onPinUnpinTemplate(messageTemplate)
                                    }
                                    metaData={metaData.data}
                                    save={(value: any) =>
                                      updateDisplayName &&
                                      updateDisplayName({
                                        ...value,
                                        entityType:
                                          getEntityTypeForPayload(entityType),
                                      })
                                    }
                                  />
                                );
                              }
                            }
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {filterMessageTemplates(messageTemplates.data, filter)
                    .length === 0 && (
                    <div className="d-flex justify-content-center">
                      <div className="d-flex mt-4">
                        <$Empty
                          image={$Empty.PRESENTED_IMAGE_SIMPLE}
                          description={
                            <span>
                              {t("US.COLLECTION.CASE:MASSAGETEMPLATES.NO_DATA")}
                            </span>
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </$Skeleton>
            </div>
          </div>

          <TemplateDrawerV2 />
        </>
      )}
    </Formik>
  );
};

const mapStateToProps = (state: RootState) => {
  const { messageTemplate, domainView } = state;
  const { messageTemplates } = messageTemplate;
  const { metaData } = domainView;
  return {
    messageTemplates,
    metaData
  };
};

const mapDispatchToProps = {
  getMessageTemplates: messageTemplates.get,
  deleteMessageTemplate: deleteMessageTempale.delete,
  pinUnpinTemplate: pinUnpinTemplate.send,
  updateDisplayName: displayName.update,
  handleDrawer: messageContent.openDrawer
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(MessageTemplates);
